import React from 'react';
import { FiDivideCircle, FiXCircle, FiClock, FiCheckCircle, FiPlusCircle} from "react-icons/fi"


const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
]

export default function ItemWStat(props) {
    const { status } = props
    let color = 'white'

    if (status) {
        if (status === 'Booked' || status === "Paid") { color = 'green' }
        else if (status === 'Requested') { color = "var(--org)" }
        else if (status === 'Canceled') { color = "var(--red)" }
        else if (status === 'Expired') { color = "var(--ltg)" }
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <p className="colorYORP listText" style={{ marginRight: 5, color: color, fontSize: 14, fontWeight: 'bold' }}>{status ? status : 'Book'}</p>
            {status === 'Requested' && <FiDivideCircle style={{fontSize: 22, color: "var(--org)"}}/>}
            {status === 'Canceled' && <FiXCircle style={{fontSize: 16, color: "var(--red)"}} />}
            {status === 'Expired' && <FiClock style={{fontSize: 16, color: "var(--ltg)"}}/>}
            {status === 'Booked' || status === 'Paid' && <FiCheckCircle style={{fontSize: 16, animation: "colorYORP 8s linear infinite"}} />}
            {!status && <FiPlusCircle style={{fontSize: 16, color: "white"}}/>}
        </div>
    )
}